module.exports = __webpack_public_path__ + "img/clipboard.0b115317.svg";